import { render, staticRenderFns } from "./UserTrainingCourses.vue?vue&type=template&id=6df7086c&"
import script from "./UserTrainingCourses.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports